//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  recognitionFaceId,
  recognitionIdCard,
  uploadNewStudentIdCard,
  queryCheckConfig,
} from '@/https/enrollCheckIdentify'
import checkFront from '@/assets/img/check_front.png'
import { danger } from '@/utils/notify.js'
import { warning } from '@/utils/notify'
import { checkCard } from '@/utils/validator'
import EmptyImg from '@/assets/img/no_search.png'

export default {
  data () {
    return {
      emptyMsg: '',
      emptyImg: EmptyImg,
      checkFront,
      checkConfig: '',
      uploadList: [],
      loading: false,
      formData: {
        zjhm: '',
        xm: '',
      },
    }
  },

  async created () {
    this.loading = true
    const { data } = await queryCheckConfig()
    this.checkConfig = data || ''
    this.loading = false
  },

  computed: {
    isNotCanCheck () {
      this.emptyMsg = this.checkConfig || ''

      return this.emptyMsg.length > 0
    },
  },

  methods: {
    uploadNewStudentIdCard,

    async uploadSuccess (val) {
      this.doCheck({
        cardSide: 'FRONT',
        imageUrl: val[0].url,
      })
    },

    async doCheck (params) {
      const { message, code, data } = await recognitionIdCard(params)

      if (code !== 0) {
        danger(message)
      } else {
        this.formData.zjhm = data.idNum
        this.formData.xm = data.name
      }
    },

    async doSubmit () {
      if (!this.formData.zjhm) {
        warning('请上传身份证正面照或输入身份证号码！')

        return
      }

      if (!checkCard(this.formData.zjhm)) {
        warning('身份证号码格式不正确！')

        return
      }

      if (!this.formData.xm) {
        warning('请上传身份证正面照或输入姓名！')

        return
      }

      if (this.formData?.xm?.length >= 30) {
        warning('姓名不能超过30个字符')

        return
      }

      this.submit()
    },

    async submit () {
      this.loading = true
      const { code, message, data } = await recognitionFaceId({
        ...this.formData,
        zjzdz: this.uploadList[0]?.url,
      })

      if (code !== 0) {
        danger(message)
      } else {
        const a = document.createElement('a')

        a.setAttribute('href', data)
        a.click()
      }

      this.loading = false
    },
  },
}
